import { useEffect } from "react";
import {
  useFlexLayout,
  usePagination,
  useResizeColumns,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { setObjectDetails } from "../../redux/reducers/objectSlice";
import { useAppDispatch } from "../../redux/stateHooks";

const ListDataRecords = ({
  title,
  columns,
  data,
  imageColumns,
  setImageColumns,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds, pageIndex, pageSize },
    toggleAllRowsSelected,
    page, // Use the page, not rows, for rendering
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 7 }, // Start at the first page
    },
    useSortBy,
    usePagination, // Place usePagination before useRowSelect
    useRowSelect, // useRowSelect should come after usePagination
    useResizeColumns,
    useFlexLayout
  );

  const dispatch = useAppDispatch();
  useEffect(() => {
    // console.log(selectedFlatRows);
    dispatch(
      setObjectDetails({
        seletedRecords: selectedFlatRows.map((row) => row.original),
      })
    );
  }, [selectedFlatRows]);

  const handleImageClumns = (value) => {
    let _imageColumns = imageColumns;
    // searching and removing
    const index = _imageColumns.indexOf(value);
    if (index !== -1) {
      _imageColumns.splice(index, 1);
    } else {
      _imageColumns.push(value);
    }
    setImageColumns([..._imageColumns]);
  };

  return (
    <fieldset className="">
      <legend>{title}</legend>
      <div className="h-full overflow-x-auto m-1 w-full">
        <table
          {...getTableProps()}
          className="min-w-full table-auto border-collapse w-full border !border-black"
        >
          <thead className="border-b border-black">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} className="">
                <th className="p-2">
                  <input
                    type="checkbox"
                    onChange={(e) =>
                      toggleAllRowsSelected(e.currentTarget.checked)
                    }
                  />
                </th>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={`p-2 text-left border-r border-black flex justify-between items-center ${
                      column.isSorted
                        ? column.isSortedDesc
                          ? "desc"
                          : "asc"
                        : ""
                    }`}
                    style={{ ...column.getHeaderProps().style }}
                  >
                    {column.render("Header").replace("__c", "")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                    <div {...column.getResizerProps()} className="resizer" />
                    <div className=" flex flex-wrap items-center">
                      <input
                        className="mr-1 ml-1"
                        type="checkbox"
                        name={column.render("Header") + "_isColumnIsImage"}
                        value="Y"
                        checked={imageColumns.includes(column.render("Header"))}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleImageClumns(column.render("Header"));
                        }}
                      />{" "}
                      <span className="mr-2">Image</span>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="">
            {page.length > 0 ? (
              <>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className={`border-black hover:bg-[#3d3c3d] ${
                        row.isSelected ? "selected-color" : ""
                      }`}
                      onClick={(e) => {
                        // console.log(row.isSelected);
                        row.toggleRowSelected(!row.isSelected);
                      }}
                    >
                      <td className="p-2 border-b border-black">
                        <input
                          type="checkbox"
                          checked={row.isSelected}
                          onChange={() => {}}
                        />
                      </td>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          className="p-2 border-b border-r border-black text-nowrap text-ellipsis overflow-hidden "
                        >
                          <abbr
                            title={
                              cell.value && typeof cell.value === "object"
                                ? Object.entries(cell.value)
                                    .map(([key, value]) => `${value ?? ""}`)
                                    .filter((x) => x !== "")
                                    .join(", ")
                                : cell.value
                            }
                            className=" !no-underline"
                          >
                            {cell.value && typeof cell.value === "object"
                              ? Object.entries(cell.value)
                                  .map(([key, value]) => `${value ?? ""}`)
                                  .filter((x) => x !== "")
                                  .join(", ")
                              : cell.render("Cell")}
                          </abbr>
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </>
            ) : (
              <p className="w-full text-center p-4">No data available</p>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="pagination record-page flex justify-center items-center mt-4">
          <button
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            className="px-2 py-1 mx-1"
          >
            {"<<"}
          </button>
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="px-2 py-1 mx-1"
          >
            {"<"}
          </button>
          <span className="mx-2">
            {pageIndex + 1} of {pageOptions.length}
          </span>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="px-2 py-1 mx-1"
          >
            {">"}
          </button>
          <button
            onClick={() => gotoPage(pageOptions.length - 1)}
            disabled={!canNextPage}
            className="px-2 py-1 mx-1"
          >
            {">>"}
          </button>
        </div>
      </div>
    </fieldset>
  );
};

export default ListDataRecords;
